module.exports = __webpack_public_path__ + "img/facebook.53cce265.svg";